import { render, staticRenderFns } from "./MyProjectsReceivedOffers.vue?vue&type=template&id=2b05de34&scoped=true"
import script from "./MyProjectsReceivedOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsReceivedOffers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsReceivedOffers.vue?vue&type=style&index=0&id=2b05de34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05de34",
  null
  
)

export default component.exports